import { Phone, Mail, MessageCircle, ArrowUpRight } from "lucide-react";

function digitsOnly(s = "") {
  return (s || "").replace(/[^0-9]/g, "");
}

export default function Contact({ contact = {} }) {
  const { phone = "[PHONE NUMBER]", email = "[EMAIL ADDRESS]", whatsapp = "[WHATSAPP NUMBER]" } = contact;
  const tel = digitsOnly(phone) ? `tel:${digitsOnly(phone)}` : "#";
  const mail = email.includes("@") ? `mailto:${email}` : "#";
  const wa = digitsOnly(whatsapp) ? `https://wa.me/${digitsOnly(whatsapp)}` : "#";

  return (
    <section id="contact" className="py-24 md:py-32 bg-[#EFEAE4]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl mb-12 reveal">
          <div className="text-[11px] uppercase tracking-[0.35em] text-[#985F47] mb-5">Direct contact</div>
          <h2 className="serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tightest text-[#2C392F] font-light">
            Call or write <span className="italic text-[#985F47]">to us.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          <a
            data-testid="contact-phone"
            href={tel}
            className="reveal bg-[#F7F5F0] border border-[#2C392F]/10 rounded-2xl p-8 hover:border-[#985F47]/40 transition-all group block"
          >
            <Phone className="text-[#985F47] mb-6" strokeWidth={1.4} />
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#985F47]">Phone</div>
            <div className="serif text-2xl md:text-3xl text-[#2C392F] mt-3 leading-tight break-all">{phone}</div>
            <div className="mt-6 inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.2em] text-[#2C392F]/70 group-hover:text-[#2C392F]">
              Call <ArrowUpRight size={14} />
            </div>
          </a>

          <a
            data-testid="contact-email"
            href={mail}
            className="reveal bg-[#F7F5F0] border border-[#2C392F]/10 rounded-2xl p-8 hover:border-[#985F47]/40 transition-all group block"
          >
            <Mail className="text-[#985F47] mb-6" strokeWidth={1.4} />
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#985F47]">Email</div>
            <div className="serif text-2xl md:text-3xl text-[#2C392F] mt-3 leading-tight break-all">{email}</div>
            <div className="mt-6 inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.2em] text-[#2C392F]/70 group-hover:text-[#2C392F]">
              Write <ArrowUpRight size={14} />
            </div>
          </a>

          <a
            data-testid="contact-whatsapp"
            href={wa}
            target="_blank"
            rel="noreferrer"
            className="reveal bg-[#2C392F] text-[#F7F5F0] rounded-2xl p-8 hover:bg-[#1E2823] transition-all group block"
          >
            <MessageCircle className="text-[#D89B7E] mb-6" strokeWidth={1.4} />
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#D89B7E]">WhatsApp</div>
            <div className="serif text-2xl md:text-3xl mt-3 leading-tight break-all">{whatsapp}</div>
            <div className="mt-6 inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.2em] text-[#F7F5F0]/70 group-hover:text-[#F7F5F0]">
              Message <ArrowUpRight size={14} />
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
